export const AddMetric = [{
    key: 'metric_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'metric_name',
        label: 'Name',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}, {
    key: 'metric_description',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'metric_description',
        label: 'Description',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

}, {
    key: 'metric_top_5_name',
    type: 'text',
    value: '',
    valid: false,
    elementConfig: {
        name: 'metric_top_5_name',
        label: 'Top 5 Name',
        placeholder: ''
    },
    validation: {
        required: true,
        message: "is required"
    },

},
{
    key: 'metric_type',
    type: 'select',
    value: '',
    valid: false,
    elementConfig: {
        name: 'metric_type_name',
        label: 'Type',
        options: [{
            metric_type: 'metric',
            metric_type_name: 'Metric'
        }, {
            metric_type: 'competency',
            metric_type_name: 'Competency'
        }, {
            metric_type: 'value',
            metric_type_name: 'value'
        }],
    },
    validation: {
        required: true,
        message: "is required"
    }
}
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/DefineMetrics/formData.js